import { Button, IconWhiskDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { getUrlWithoutQueryParams } from 'libs/utils'
import { trackEmailRecipeClick } from './events'

const EmailRecipeButton = () => {
  const { article } = useStaticData()
  const { t } = useTranslation('@mc/next')

  const linkPath = t('article.subsections.recipe.mailto', {
    title: article.title,
    text: article.descriptionPlainText,
    url: getUrlWithoutQueryParams(article.slug),
  })

  const handleClick = () => {
    trackEmailRecipeClick(linkPath, t('article.subsections.recipe.linkCopy'))
  }

  return (
    <div className='col-lg-5'>
      <Button onClick={handleClick} as='a' href={linkPath}>
        <IconWhiskDefault className='mc-mr-3' />
        {t('article.subsections.recipe.linkCopy')}
      </Button>
    </div>
  )
}

export default EmailRecipeButton
